<span class="description category">{{ category }}</span>
<ngb-rating [(rate)]="rate" class="rating">
  <ng-template let-fill="fill">
    <span class="star" [class.star__filled]="fill === 100">&#9733;</span>
  </ng-template>
</ngb-rating>
<span class="description value">{{ rate }} / 10</span>
